import React from 'react';

import { BaseButton } from '@components/primitives';
import { SimpleCircleSpinner } from '@components/spinners';

import type { ActionButtonProperties } from './ActionButton.types';

export const ActionButton: React.FC<ActionButtonProperties> = ({
  dataTest = 'action_button',
  onClick,
  isSubmitting,
  isDisabled,
  color,
  label,
  type = 'button',
  variant = 'contained',
  size = 'large',
  sx,
  spinnerSize = '20',
  form,
  endIcon,
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <BaseButton
      dataTest={dataTest}
      color={color}
      variant={variant}
      type={type}
      onClick={handleClick}
      disabled={isSubmitting || isDisabled}
      size={size}
      form={form}
      startIcon={
        <SimpleCircleSpinner size={spinnerSize} isLoading={isSubmitting} />
      }
      endIcon={endIcon}
      sx={{ width: '100%', ...sx }}
    >
      {label}
    </BaseButton>
  );
};
